<template>
  <div class="bg-gray-200 font-opensans rounded-lg shadow-lg">
    <div
      class="py-2 px-2 text-center font-bold uppercase tracking-wide bg-mi-blue-500 rounded-t-lg text-gray-100 truncate"
    >
      {{ header }}
    </div>
    <ul class="px-2 py-2" v-if="disabled">
      <li v-for="sport in sporten" :key="sport.code">{{ sport.naam }}</li>
    </ul>
    <FormulateForm
      v-else
      v-model="values"
      :schema="schema"
      class="m-2"
      @submit="submitHandler"
    />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "SportCard",
  props: ["vz"],
  data: function() {
    return {
      header: "Sporten",
      disabled: !this.hasPermission("update voorziening"),
      sporten: this.vz.sporten,
      values: {
        sporten: this.vz.sporten.map(sport => sport.id)
      }
    };
  },
  computed: {
    ...mapGetters({
      options_sports: "sports_flattened"
    }),
    schema: function() {
      return [
        {
          type: "select",
          name: "sporten",
          label: "Sporten",
          disabled: this.disabled,
          options: this.options_sports.map(this.shorten_label),
          "input-class": this.disabled ? "disabled" : "bg-transparent",
          multiple: true
        },

        {
          type: "submit",
          "input-class": ["btn", "btn-blue", this.disabled ? "disabled" : ""],
          label: "Opslaan"
        }
      ];
    }
  },
  methods: {
    submitHandler: async function(data) {
      let updatedVoorziening = {};
      updatedVoorziening["sporten"] = data["sporten"].map(sport => ({
        id: sport
      }));
      const [ok, msg] = await this.$store.dispatch("updateVoorziening", {
        id: this.vz.id,
        properties: updatedVoorziening
      });
      this.parseReponse(ok, msg);
    },
    shorten_label: item => ({
      // TODO: this is a temp bug fix for size of field
      // We may be able to fix this with CSS
      // This impacts position of mobile nav
      ...item,
      label: item.label.slice(0, 20)
    })
  }
};
</script>
